import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-soluadilar-fasteignasolur',
  templateUrl: './soluadilar-fasteignasolur.component.html',
  styleUrls: ['./soluadilar-fasteignasolur.component.scss']
})
export class AboutSoluadilarFasteignasolurComponent implements OnInit {

  environment = environment;

  constructor() { }

  ngOnInit(): void {
  }

}
